import { call, put, all } from "redux-saga/effects";
import { loginAPI, autoLoginAPI } from "../api/LoginCalls";
import { loginFailure, loginSuccess } from "../actions/loginactions";
import { moveToLoginPage, moveToMainPage } from "../actions/routeactions";
import { reportError } from "../actions/erroractions";

export function* loginSaga(action) {
  const result = yield call(loginAPI, action);

  try {
    if (result === 200) {
      yield all([put(loginSuccess()), put(moveToMainPage(true))]);
    } else if (result === 401) {
      yield all([
        put(loginFailure()),
        put(reportError("Incorrect username or password")),
      ]);
    } else if (result === 423) {
      yield all([
        put(loginFailure()),
        put(
          reportError(
            "Account has been locked for a 5 minutes period, too many failed login requests"
          )
        ),
      ]);
    } else {
      yield all([
        put(loginFailure()),
        put(reportError("Unable to reach server")),
      ]);
    }
  } catch (ex) {
    yield all([
      put(loginFailure()),
      put(reportError("Unable to reach server")),
    ]);
  }
}

export function* autoLoginSaga() {
  try {
    const result = yield call(autoLoginAPI);

    if (result === 200) {
      yield put(moveToMainPage(true));
    } else {
      yield put(moveToLoginPage());
    }
  } catch (ex) {
    yield put(moveToLoginPage());
  }
}
